import { Login, GetUserInfo, CompanyRecharge, GetAgent, GetCode, ReSetPwd, userCompany, SaveCompany, SavePassword} from '@/api/user'
import { setToken, getToken, canTurnTo } from '@/libs/util'
export default {
  state: {
    company: {},
    access: [],
    token: getToken()
  },
  getters: {
    company: state => state.company,
    access: state => state.access
  },
  actions: {
    // 登录
    HandleLogins ({ commit }, payload) {
      try {
        payload.tel = payload.tel.trim()
        return new Promise((resolve, reject) => {
          Login(payload).then(res => {
            if (res.data.status) {
              setToken(res.data.token)
              // commit('SET_COMPANY', res.data.data)
            }
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 退出登录
    HandleLogOut ({ state, commit }) {
      setToken('')
      commit("SET_COMPANY", {})
    },
    // 获取用户相关信息
    GetUserInfo ({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          GetUserInfo().then(res => {
            if (res.data) {
              commit('SET_COMPANY', res.data)
            } else {
              setToken('')
            }
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    CompanyRecharge ({ commit }, payload) {
      return new Promise(resolve => {
        CompanyRecharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAgent ({ commit }, payload) {
      return new Promise(resolve => {
        GetAgent(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetCode ({ commit }, payload) {
      return new Promise(resolve => {
        GetCode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ReSetPwd ({ commit }, payload) {
      return new Promise(resolve => {
        ReSetPwd(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    userCompany ({ commit }, payload) {
      return new Promise(resolve => {
        userCompany(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveCompany ({ commit }, payload) {
      return new Promise(resolve => {
        SaveCompany(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SavePassword ({ commit }, payload) {
      return new Promise(resolve => {
        SavePassword(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  mutations: {
    SET_COMPANY (state, payload) {
      console.log(payload)
      if(!payload.power){
        state.access = ["company_admin"]
      }
      state.company = payload
      //
    }
  }
}
